import { render, staticRenderFns } from "./DepartmentOrderNextInfoAfterCreateOrderTour.vue?vue&type=template&id=f31f55f8"
import script from "./DepartmentOrderNextInfoAfterCreateOrderTour.vue?vue&type=script&lang=js"
export * from "./DepartmentOrderNextInfoAfterCreateOrderTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports